var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.453 1.45317C13.9463 0.946504 13.2663 0.666504 12.5597 0.666504H2.99967C1.53301 0.666504 0.333008 1.8665 0.333008 3.33317V24.6665C0.333008 26.1332 1.51967 27.3332 2.98634 27.3332H18.9997C20.4663 27.3332 21.6663 26.1332 21.6663 24.6665V9.77317C21.6663 9.0665 21.3863 8.3865 20.8797 7.89317L14.453 1.45317ZM14.9997 21.9998H6.99967C6.26634 21.9998 5.66634 21.3998 5.66634 20.6665C5.66634 19.9332 6.26634 19.3332 6.99967 19.3332H14.9997C15.733 19.3332 16.333 19.9332 16.333 20.6665C16.333 21.3998 15.733 21.9998 14.9997 21.9998ZM14.9997 16.6665H6.99967C6.26634 16.6665 5.66634 16.0665 5.66634 15.3332C5.66634 14.5998 6.26634 13.9998 6.99967 13.9998H14.9997C15.733 13.9998 16.333 14.5998 16.333 15.3332C16.333 16.0665 15.733 16.6665 14.9997 16.6665ZM12.333 8.6665V2.6665L19.6663 9.99984H13.6663C12.933 9.99984 12.333 9.39984 12.333 8.6665Z",
    fill: "#5F6CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionBlue);
export default __webpack_public_path__ + "static/media/descriptionBlue.d5741ef953bf940862134d416aad3589.svg";
export { ForwardRef as ReactComponent };